<template>
    <div class="ListFilters row margin-bottom-medium">
        <div class="col-xs-12 col-sm-6">
            <div class="st-filters">
                <div class="inline">
                    <button
                    class="st-filters__link"
                    :class="{'st-filters__link--active': !hasFilters() }"

                    @click="reset">{{ $t("All") }} ({{ role.total }})</button><span v-if="role.subroles || channel.me.role != role.name"> | </span>
                </div>

                <div class="inline" v-if="channel.me.role != role.name">
                    <button class="st-filters__link" :class="{'st-filters__link--active': filters.my }" @click="toggleMy()">{{ $t("My") }}</button>
                </div>
				<div class="inline" v-if="leader_role">
					<span> | </span>
					<button
                    class="st-filters__link"
                    :class="{ 'st-filters__link--active': filters.roles.indexOf(leader_role.name) >= 0 }"
                    @click="toggleRole(leader_role.name)"
                    >{{ $t(leader_role.singular) }} ({{ leader_role.total }})</button>
				</div>
                <div class="inline" v-if="role.subroles">
                	<span> | </span>
                    <div class="inline" v-for="sr in role.subroles">
                        <button
                        class="st-filters__link"
                        :class="{ 'st-filters__link--active': filters.roles.indexOf(sr.name) >= 0 }"
                        @click="toggleRole(sr.name)"
                        >{{ $t(sr.singular) }} ({{ sr.total }})</button><span v-if="!isLast(role.subroles, sr)"> | </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xs-12 col-sm-6 text-sm-right">

            <input
            type="text"
            class="st-input st-input--sm st-input--text st-input--search"

            :placeholder="$t('Search ...')"
            v-model="filters.q"
            @keyup="update" />

            <div class="inline-block">
				<v-paging
				:current_page="parseInt(filters.page)"
				:min_page="1"
				:max_page="pages"
				@pagechange="changePageByNumber" @
				prev="changePage"
				@next="changePage"
				></v-paging>
            </div>
        </div>
    </div>
</template>

<script>
import VPaging from '@/components/v-paging';
import debounce from 'lodash/debounce';
import isEmpty from 'lodash/isEmpty';
import forEach from 'lodash/forEach';
import merge from 'lodash/merge';
import isEqual from 'lodash/isEqual';

export default {
  	name: 'ListFilters',
  	components: {
  		VPaging
  	},
	computed: {
		loading(){
			return this.$store.getters.loading;
		},
		channel(){
			return this.$store.getters.channel;
		},
		role(){
			if(this.rolename) return this.$store.getters.channel.roles[this.rolename];
			return false;
		},
		leader_role(){
			if(this.role && this.role.leader){
				return this.$store.getters.channel.roles[this.role.leader];
			}
			return false;
		}
	},
	props: {
		totals: {
			default(){
				return {};
			}
		},
		rolename: {
			default: ''
		}
	},
	data(){
		return {
			page: 1,
	    	pages: 1,
	    	debounceEvents: debounce(this.sendEvent, 300),
	    	query: {},
	    	init: false,
	    	filters: {
	    		q: '',
	    		page: 1,
	    		limit: 10,
	    		my: false,
	    		roles: [],
	    	},
		}
	},
	mounted(){
		let query = JSON.parse(JSON.stringify(this.$route.query));

		forEach(query, (value, key) => {
			if(typeof this.filters[key] !== 'undefined') {
				if(Array.isArray(this.filters[key]) && !Array.isArray(value)){
					this.filters[key] = [value];
				} else {
					this.filters[key] = value;
				}
			}
		});

		this.update();
	},
	destroyed(){this.reset(false);},
  	methods: {
  		update(){
  			let pre = JSON.parse(JSON.stringify(this.query)),
  				query = {};

			forEach(this.$route.query, (value, key) => {
  				query[key] = JSON.parse(JSON.stringify(value));
  			});

  			forEach(this.filters, (value, key) => {
  				query[key] = JSON.parse(JSON.stringify(value));
  			});

  			query.q = query.q.trim();
  			if(query.q.length <= 2) query.q = '';


  			forEach(query, (value, key) => {
  				if(typeof value === 'boolean') {
  					if(key == 'my' && value===false) delete query[key];
  				} else if(typeof value == 'number'){
  					if(
  						(key == 'page' && value == 1) ||
  						(key == 'limit' && value == 10)
  						) {
  						delete query[key];
  					}
  				} else {
  					if(isEmpty(value)) delete query[key];
  				}
  			});

  			var eq = !isEqual(pre, query);
			if(eq || !this.init){
				this.init = true;
				this.debounceEvents(query);
			}
  		},
  		sendEvent(query){
  			// this.$router.replace({ query });
			this.$emit('update', {...query});
			this.query = query;
  		},
  		reset(update){
  			this.filters = {
	    		q: '',
	    		page: 1,
	    		limit: 10,
	    		my: false,
	    		roles: [],
	    	};
	    	if(update) this.update();
  		},
  		changePageByNumber(numb){
  			this.filters.page = numb;
  			this.update();
  		},
		changePage(add){
			this.filters.page = this.filters.page + add;
			this.update();
		},
  		hasFilters(){
  			var min = 0;
  			if(this.query.q) min+=1;
  			return Object.keys(this.query).length > min;
  		},
  		toggleRole: function(name){
			if(typeof this.filters.roles != 'object') this.filters.roles = [];
			const self = this,
				  index = self.filters.roles.indexOf(name);

			if (index === -1) {
		        self.filters.roles.push(name);
		    } else {
		    	self.filters.roles.splice(index, 1);
		    }
		    this.update();
		},
  		toggleMy(){
  			this.filters.my = !this.filters.my;
  			this.update();
  		},
  		isLast(arr, obj){
			return arr.length -1 == arr.indexOf(obj);
		},
  	}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ListFilters.vue